import { JourneyCanvasState, NotifyDialogStatus } from '../../utility/TypeDefs';
import { NotifyDeleteCemPayload, NotifyDeleteConnectorPayload, NotifyDeleteNodePayload } from '../TypeDefs';

/**
 * @method hideDeleteNotifyDialog
 * @description set showNotifyDialog to false
 * @param state Journey canvas state
 * @returns showNotifyDialog
 */
export const hideDeleteNotifyDialog = (state: JourneyCanvasState): JourneyCanvasState => ({
  ...state,
  showNotifyDialog: false,
});

/**
 * @method notifyDeleteNode
 * @description show notification to delete node when clicked on delete button
 * @param state Journey canvas state
 * @param nodeId node Id of the flow item
 * @returns show popup notification for delete node
 */
export const notifyDeleteNode = (state: JourneyCanvasState, {
  nodeId
}: NotifyDeleteNodePayload): JourneyCanvasState => ({
  ...state,
  notifyDialogStatus: NotifyDialogStatus.DELETE_NODE,
  showNotifyDialog: true,
  deletingNodeId: nodeId
});

/**
 * @method notifyDeleteCem
 * @description show delete compensatory event map notification when clicked on delete compensatory eventMap button
 * @param state Journey canvas state
 * @param name compensatory event map name
 * @returns show delete compensatory event map notification popup
 */
export const notifyDeleteCem = (state: JourneyCanvasState, {
  name
}: NotifyDeleteCemPayload): JourneyCanvasState => ({
  ...state,
  notifyDialogStatus: NotifyDialogStatus.DELETE_CEM,
  showNotifyDialog: true,
  deletingCEMName: name
});

/**
 * @method notifyDeleteStep
 * @description show delete step notification when clicked on delete from step card menu
 * @param state Journey canvas state
 * @returns show delete step notification popup
 */
export const notifyDeleteStep = (state: JourneyCanvasState): JourneyCanvasState => ({
  ...state,
  notifyDialogStatus: NotifyDialogStatus.DELETE_STEP,
  showNotifyDialog: true,
  stepCardMenuDropdown: {
    ...state.stepCardMenuDropdown,
    isVisible: false
  }
});

/**
 * @method notifyDeleteConnector
 * @description show delete connector notification when clicked on delete connector icon
 * @param state Journey canvas state
 * @param from connector from node ID
 * @param to connector to node ID
 * @returns show delete connector notification popup
 */
export const notifyDeleteConnector = (state: JourneyCanvasState, {
  from,
  to
}: NotifyDeleteConnectorPayload): JourneyCanvasState => ({
  ...state,
  notifyDialogStatus: NotifyDialogStatus.DELETE_CONNECTOR,
  showNotifyDialog: true,
  deletingConnector: { from, to }
});

/**
 * @method notifyApiError
 * @description Set notifyApiError to true
 * @param state Journey canvas state
 * @param description notifyApiError
 */
export const notifyApiError = (state: JourneyCanvasState): JourneyCanvasState => ({
  ...state,
  notifyApiError: true
});

/**
 * @method hideApiError
 * @description Set notifyApiError to false
 * @param state Journey canvas state
 * @param description notifyApiError
 */
export const hideApiError = (state: JourneyCanvasState): JourneyCanvasState => ({
  ...state,
  notifyApiError: false
});
